import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { DatePipe } from "@angular/common";
import { TipoCambioService } from '../../services/configuracion/tipo-cambio.service';
import { MomentDateAdapter } from "@angular/material-moment-adapter";

import {
  DateAdapter,
  MAT_DATE_LOCALE
} from "@angular/material";


export const MY_FORMATS = {
  parse: {
    dateInput: "LL"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-editar-tipo-cambio',
  templateUrl: './editar-tipo-cambio.component.html',
  styleUrls: ['./editar-tipo-cambio.component.scss'],
  providers:[DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },]
})
export class EditarTipoCambioComponent implements OnInit {

  @Input() tipoCambio : any;
  @Output() cerrarEditarTipoCambio : EventEmitter<boolean>;
  form : FormGroup;
  loading : boolean;
  actualizado : boolean;
  error : boolean;
  msgAlerta : string;

  constructor( private datepipe:DatePipe ,  private tipoCambioService:TipoCambioService) {
    this.cerrarEditarTipoCambio = new EventEmitter();
    this.actualizado = false;
    this.error = false;
  }

  ngOnInit() {

    this.form = new FormGroup({
      idTCambio: new FormControl({ value :this.tipoCambio.idTCambio, disabled: false }  , [Validators.required  ]),
      Fecha: new FormControl({ value :  this.tipoCambio.Fecha, disabled: true }  , [Validators.required  ]),
      Hora: new FormControl(  { value :this.tipoCambio.Hora, disabled: true }, [Validators.required ]),
      Fuente: new FormControl({ value :this.tipoFuente(), disabled: true }, [Validators.required ]),
      Compra: new FormControl({ value :this.tipoCambio.Compra, disabled: true }, [Validators.required ]),
      Venta: new FormControl({ value :this.tipoCambio.Venta, disabled: true }, [Validators.required ]),
      Vigente_Indicador: new FormControl("S", [Validators.required ]),
      Alta_Usuario: new FormControl('71976724', [Validators.required ])
    })
    
    
  }

  tipoFuente():string{
    switch (this.tipoCambio.Fuente) {
      case 'CASA DE CAMBIO':
            return '4';
        
        case 'PÁGINA WEB SBS - OFICIAL':
            return '2';
        
        case 'BANCO':
            return '3';

        case 'COMERCIAL':
            return '5';
    
      default:
          return '1';
    } 
  }
  
  
  cerrarVentanaEditarTipoCambio(){
  this.cerrarEditarTipoCambio.emit();
  }

  guardarCambios(){

  this.loading = true;
  this.form.disable();
    

  this.tipoCambioService.editarTipoDeCambio(this.tipoCambio.idTCambio, this.form.getRawValue())
      .subscribe(resp => {
        this.error = false;
        this.loading = false;
        this.actualizado = true;
        this.msgAlerta = "¡Actualizado Correctamente!"
        this.form.enable();
    }, err => {
      this.error = true;
      
      this.msgAlerta = "¡"+err.error['error']+"!";
      this.loading = false;
      this.form.enable();
    })

  }

}
